import React from "react";
import { connect } from "react-redux";
import { withRouter } from "../../utils/withRouter";
import { DashboardHeader } from "../../components/Header";
import { CollectionAccounts } from "../../components/CollectionAccounts";

class AccountCollectionsScreen extends React.Component {
  render() {
    const { searchParams } = this.props;

    const collectionId = searchParams.get("collectionId");
    const collectionName = searchParams.get("collectionName");
    return (
      <div className="card">
        <div className="card-body">
          <DashboardHeader
            title={collectionName + " accounts"}
            titleClassName="text-primary"
          />
          <CollectionAccounts
            showAdd
            collectionId={collectionId}
            collectionName={collectionName}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(withRouter(AccountCollectionsScreen));
